import { gql } from "@/services/httpAdapter";

export const onUpdateSalesPerformanceSales = gql`
	subscription onUpdateSalesPerformanceSales($locationId: String, $commissionCycleId: String) {
		onUpdateSalesPerformanceSales(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			_id
			locationId
			commissionCycleId
			title
			period
			createdAt
			createdBy
			updatedAt
			updatedBy
			dealNumber
			funded
			customerName
			customerNumber
			dealType
			description
			financeEmployeeId
			financeEmployeeName
			financeEmployeeLocationId
			saleDate
			saleType
			salesEmployeeId
			salesEmployeeName
			salesEmployeeLocationId
			salesManagerId
			salesManagerName
			salesManagerLocationId
			stockNumber
			frontGrossProfit
			backGrossProfit
			units
			saleAmount
			frontProducts {
				product
				value
			}
			backProducts {
				product
				value
			}
			vehicleInformation {
				make
				model
				modelYear
				trim
			}
			external
			sourceLocationId
			origin {
				icon
				tooltip
			}
			dealerCodeFS
			identifiers {
				_id
				locationName
				dealerCodeFS
				locationId
				oemName
			}
		}
	}
`;

export const onExportCrossStoreReconciliationHistory = gql`
	subscription onExportCrossStoreReconciliationHistory($locationId: String!, $commissionCycleId: String!) {
		onExportCrossStoreReconciliationHistory(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			locationId
			commissionCycleId
			salesPerformances {
				_id
				exportedId
				exportedOn
				exportedBy
				exportedType
				exportedBalance
				salesPerformanceId
				locationId
				commissionCycleId
				payPeriodId
				funded
				saleDate
				dealNumber
				stockNumber
				salesEmployeeId
				salesEmployeeName
				salesEmployeeLocationId
				financeEmployeeId
				financeEmployeeName
				financeEmployeeLocationId
				salesManagerId
				salesManagerName
				salesManagerLocationId
				customerName
				customerNumber
				saleType
				dealType
				units
				sourceLocationId
				external
				origin {
					icon
					tooltip
				}
				frontGrossProfit
				backGrossProfit
				commissions {
					locationId
					userId
					employeeId
					employeeName
					position
					frontCommission
					backCommission
					grossCommission
					frontCommissionExport
					backCommissionExport
				}
			}
		}
	}
`;
